'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".Header-module_header__RDN94{color:#000;font-family:inherit;font-weight:700;margin:0}.Header-module_hugeHeader__SbpNF{font-size:6rem}.Header-module_bigHeader__8RjOR{font-size:2.125rem}.Header-module_semiBigHeader__bDKbI{font-size:1.5rem}.Header-module_mediumHeader__DI4D6{font-size:1.125rem}.Header-module_smallHeader__f8K0m{font-size:.875rem}";
var styles = {"header":"Header-module_header__RDN94","hugeHeader":"Header-module_hugeHeader__SbpNF Header-module_header__RDN94","bigHeader":"Header-module_bigHeader__8RjOR Header-module_header__RDN94","semiBigHeader":"Header-module_semiBigHeader__bDKbI Header-module_header__RDN94","mediumHeader":"Header-module_mediumHeader__DI4D6 Header-module_header__RDN94","smallHeader":"Header-module_smallHeader__f8K0m Header-module_header__RDN94"};
styleInject["default"](css_248z, '3d7f9405-09c0-46bf-a57b-45f35628ff8e');

exports["default"] = styles;
